import { stringify } from "qs";
import { z } from "zod";

import { ShiftInviteStatus } from "../type";

export const shiftInvitesDateRangeFilterSchema = z.object({
  filter: z.object({
    workplaceId: z.string(),
    shiftDetails: z.object({
      start: z.object({
        gte: z.string(),
        lte: z.string(),
      }),
    }),
    status: z.array(z.nativeEnum(ShiftInviteStatus)),
  }),
});

export type ShiftInvitesDateRangeFilter = z.infer<typeof shiftInvitesDateRangeFilterSchema>;

interface BuildShiftInvitesDateRangeFilterParams {
  workplaceId: string;
  start: string;
  end: string;
  status: ShiftInviteStatus[];
}

/**
 * Shared `filter` shape for `SHIFT_INVITES_URL` list queries, used by both the
 * daily view's per-day invite fetch and the monthly view's range-wide count fetch.
 */
export function buildShiftInvitesDateRangeFilter(
  params: BuildShiftInvitesDateRangeFilterParams
): ShiftInvitesDateRangeFilter {
  const { workplaceId, start, end, status } = params;
  return {
    filter: {
      workplaceId,
      shiftDetails: { start: { gte: start, lte: end } },
      status,
    },
  };
}

export function serializeShiftInvitesQueryParams(queryParameters: unknown): string {
  return stringify(queryParameters, { arrayFormat: "brackets" });
}
